module.exports = __webpack_public_path__ + "img/bg--pattern_cream.44d308b2.png";